import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

interface CategoriesProps {
  modeView: string;
}

export const CategoriesStack = styled(Stack)<CategoriesProps>`
  ${({ modeView, theme }) =>
    modeView === 'grid'
      ? `
  flex-direction: row;
  gap: 16px;
  & > :not(:first-child) {
    border-left: 1px solid ${theme.palette.grey['01']};
  }
    `
      : `flex-direction: column;`}
`;

export const InfoStack = styled(Stack)`
  flex-direction: column;
  width: 100%;
  padding: 16px;
`;

export const InfoHeader = styled(Stack, {
  shouldForwardProp: (prop) => !['color'].includes(prop as string),
})<{ color: string }>`
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid ${({ color }) => color};
  padding-bottom: 8px;
  margin-bottom: 8px;
`;
